import type { SearchDriverStatus } from '../enums/SearchDriverStatus'

export class DriverAssignmentFilterEntity {
  id!: number
  searchWord?: string
  from?: string
  to?: string
  statuses?: Array<SearchDriverStatus>
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
